import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import { isMobile } from '../../../../utilties/mobileDetector'

export default ({ width, height }) => {
	const canvas = useRef(null)
	const [ margin ] = useState({ top: 20, right: 80, bottom: 30, left: 50 })
	const [ ] = useState({ top: 20 })

	useEffect(() => {
		if (canvas && canvas.current) {
			setup()
			lineChart(width, height)
		}

		// Hide tooltip on mobiles when chart scrolled horizontally
		if (document.getElementById('chartWrapper') !== null) {
			document.getElementById('chartWrapper').addEventListener('scroll', ()=>{
				var box = document.getElementById('tooltip');
				box.style.transitionDuration = "0.1s";
				box.style.opacity = "0";
			})
		}
	}, [])

	const setup = () => {
		height = 300 - margin.top - margin.bottom
		if (isMobile) {
			width = 600 - margin.left - margin.right
		} else {
			width = 780 - margin.left - margin.right
		}
	}

	const lineChart = (width, height) => {
		var x = d3.scaleLinear().range([ 0, width ])
		var y = d3.scaleLinear().range([ height, 0 ])

		const svg = d3.select(canvas.current).select('svg').attr('width', 780).attr('height', 400)
		if (isMobile) {
		}

		var yAxis = d3.axisRight().scale(y)

		function drawChart() {
			x.domain(
				d3.extent([], function(d) {
					return parseInt(d.xAxis)
				})
			)
			svg.selectAll('*').remove()

			svg
				.append('g')
				.attr('class', 'grid')
				.style('stroke-opacity', '0.6')
				.style('stroke-dasharray', '3, 3')
				.style('color', '#fff')
				.style('shape-rendering', 'crispEdges')
				.attr('transform', 'translate(40, 30)')
				.call(d3.axisLeft(y).ticks(4).tickSize(-width).tickFormat(''))

			svg.select('.domain').style('color', '#11121C')

			svg
				.append('g')
				.attr('class', 'x axis')
				.attr('color', '#11121C')
				.attr('transform', 'translate(40,280)')
				.append('text')
				.attr('fill', '#11121C')
				.attr('font-size', '16px')
				.attr('transform', 'translate(' + width / 2 + ', 50)')

			svg
				.append('g')
				.attr('class', 'y axis')
				.attr('color', '#11121C')
				.attr('transform', 'translate(' + (width + 40) + ', 30)')
				.call(
					yAxis.ticks(0).tickPadding(15).tickSize(0).tickFormat(function(d) {
						return d
					})
				)
				.append('text')
				.attr('transform', 'translate(' + width + ', 0)')
				.attr('transform', 'rotate(-270)')
				.attr('fill', '#11121C')
				.attr('y', -50)
				.attr('x', 170)
				.attr('dy', '.50em')
				.attr('font-size', '16px')
				.attr('font-weight', 'bold')
				.style('text-anchor', 'end')
		}

		drawChart()
	}
	if (isMobile) {
		return (
			<div id='chartWrapper'>
				<div ref={canvas} id='chart' data-testid="empty-chart" style={{ width: 600, height: 410, margin: '0 auto' }}>
					<div id='tooltip' />
					<svg />
				</div>
			</div>
		)
	} else {
		return (
			<div ref={canvas} id='chart' data-testid="empty-chart" style={{ width: 780, height: 410, margin: '0 auto' }}>
				<div id='tooltip' />
				<svg />
			</div>
		)
	}
}
